import React from 'react';

import { Actions, Action, EditIcon, DeleteIcon } from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_SHARE_GROUP,
  ACTION_RENAME_GROUP,
  ACTION_DELETE_GROUP,
} from './constants';

export const GroupActions = ({
  isPublic,
  onShare,
  onRemove,
  onRename,
  limit,
  actions,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Actions limit={limit}>
          {isActionAllowed(ACTION_SHARE_GROUP) ? (
            <Action
              button={true}
              label={isPublic ? 'Unshare' : 'Share'}
              onClick={onShare}
            />
          ) : null}
          {isActionAllowed(ACTION_RENAME_GROUP) ? (
            <Action icon={<EditIcon />} label={'Rename'} onClick={onRename} />
          ) : null}
          {isActionAllowed(ACTION_DELETE_GROUP) ? (
            <Action icon={<DeleteIcon />} label={'Delete'} onClick={onRemove} />
          ) : null}
        </Actions>
      )}
    </Permissions>
  );
};

export default GroupActions;
